/** The header's Month / Week / List switch. */
import { PILL_BOX } from './workshops-calendar-header-styles';
import type { CalendarView } from './workshopsCalendarTypes';

export function WorkshopsCalendarViewToggle({
  views,
  view,
  onSetView,
}: {
  views: CalendarView[];
  view: CalendarView;
  onSetView: (v: CalendarView) => void;
}) {
  return (
    <div style={{ ...PILL_BOX, alignItems: 'stretch' }}>
      {views.map((v) => (
        <button
          key={v}
          type="button"
          onClick={() => onSetView(v)}
          style={{
            height: 22,
            padding: '0 10px',
            fontSize: 10.5,
            fontWeight: 600,
            borderRadius: 999,
            border: 'none',
            cursor: 'pointer',
            color: view === v ? 'var(--nb-bark-dark)' : 'var(--nb-subtle)',
            background: view === v ? 'var(--nb-bg)' : 'transparent',
            boxShadow: view === v ? '0 1px 1px rgba(0,0,0,.08)' : 'none',
          }}
        >
          {v}
        </button>
      ))}
    </div>
  );
}
